// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__3gp1M","SearchBar__field":"SearchBar_SearchBar__field__1SQkK","SearchBar__icon":"SearchBar_SearchBar__icon__1wdDq"};